import { useMemo } from 'react';
import {
  assessmentsStatusesOptions,
  assignmentStatusesOptions,
  assessmentsPdfsStatusesOptions,
} from '../constants';
import {
  ASSESSMENT_STATUSES,
  ASSIGNMENT_STATUSES,
} from 'chameleon-src/constants/assessmentStatus';
import { resourceTypes } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';

const useGetFilterOptions = (queryParams) => {
  const filterOptions = useMemo(() => {
    if (
      ASSIGNMENT_STATUSES.find((value) =>
        queryParams?.status?.split(',').includes(value),
      )
    ) {
      return {
        type: 'assignments',
        options: assignmentStatusesOptions,
      };
    }

    if (
      ASSESSMENT_STATUSES.find((value) =>
        queryParams?.status?.split(',').includes(value),
      )
    ) {
      return {
        type: 'assessments',
        options:
          queryParams?.type === resourceTypes.pdf
            ? assessmentsPdfsStatusesOptions
            : assessmentsStatusesOptions,
      };
    }
  }, [queryParams?.status, queryParams?.type]);

  return {
    filterOptions,
  };
};

export default useGetFilterOptions;
